import React, { Component } from 'react';
import  createHistory  from 'history/createBrowserHistory';
import Help_hints from "./help_hints";
import "./css/wepcg_bar.css"

class EligibleLateDeliveryBar extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
    }
    render() {
        return <div className="bar">
            <h1><strong>Invoice Dispute (Eligible Late Delivery)</strong></h1>
            <p>
                This claim type is used if the goods delivery is delayed due to Lenovo. Before submitting a dispute, please check Order Visibility Portal whether delivery is not still in transit and what is the planned delivery date. Please contact Customer Fulfillment representative to obtain confirmation of late delivery caused by Lenovo (incl. number of days).  Contact our financial claims team in case there is any question or problem.            </p>
            <p>
                Claims for late delivery must be received by Lenovo no more than fifteen (15) working days after the planned date of delivery.            </p>
            <Help_hints />
        </div>
    }
}

export default EligibleLateDeliveryBar;